import { jsx as _jsx } from "react/jsx-runtime";
import { Box, CardMedia } from '@mui/material';
import Image from '../Image';
const CardImage = ({ product, onClick, height, maxHeight, objectFit = 'contain', imageClickable = false, borderStyle = {}, isHorizontal = false, }) => {
    const imageUrl = product?.image || product?.featured_image;
    const isCoverFullHeight = objectFit === 'cover-full-height';
    // Horizontal cards should not inherit a fixed maxHeight (e.g. 250px),
    // otherwise the image gets artificially capped and breaks card layout.
    const isHorizontalCover = isHorizontal && objectFit === 'cover';
    const effectiveMaxHeight = isHorizontalCover
        ? '300px'
        : ((!isHorizontal && !isCoverFullHeight) ? maxHeight : undefined);
    const imageObjectFit = isCoverFullHeight ? 'contain' : objectFit;
    const imageHeight = isCoverFullHeight ? 'auto' : '100%';
    if (!imageUrl) {
        const fallbackHeight = height || 200;
        return (_jsx(Box, { sx: {
                width: '100%',
                height: fallbackHeight,
                backgroundColor: '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#6b7280',
                fontSize: '0.875rem',
            }, children: "No image available" }));
    }
    return (_jsx(CardMedia, { sx: {
            width: '100%',
            maxWidth: isHorizontal ? '100%' : undefined,
            maxHeight: isHorizontalCover ? '300px' : (isHorizontal ? undefined : (isCoverFullHeight ? undefined : (effectiveMaxHeight ?? 'auto'))),
            height: isCoverFullHeight ? 'auto' : undefined,
            alignSelf: isCoverFullHeight ? 'flex-start' : 'stretch',
            justifySelf: 'start',
            display: 'flex',
            alignItems: isHorizontal ? 'flex-start' : 'center',
            justifyContent: 'center',
            overflow: 'hidden',
        }, children: imageClickable ? (_jsx(Box, { component: "a", href: product?.url, target: "_top", rel: "noreferrer", onClick: (e) => {
                e.preventDefault();
                onClick?.();
            }, sx: {
                display: 'block',
                width: '100%',
                height: imageHeight,
                cursor: 'pointer',
                lineHeight: 0,
                fontSize: 0,
            }, children: _jsx(Image, { url: imageUrl, status: "loaded", alt: product?.title || 'Product Image', customStyle: {
                    width: '100%',
                    height: imageHeight,
                    ...(effectiveMaxHeight !== undefined && { maxHeight: effectiveMaxHeight }),
                    objectFit: imageObjectFit,
                    objectPosition: isHorizontal ? 'top' : 'center',
                    ...(isHorizontal && {
                        borderTopLeftRadius: borderStyle.borderRadius || 0,
                        borderBottomLeftRadius: borderStyle.borderRadius || 0,
                    }),
                } }) })) : (_jsx(Box, { component: "div", onClick: onClick, sx: {
                display: 'block',
                width: '100%',
                height: imageHeight,
                cursor: onClick ? 'pointer' : 'default',
            }, children: _jsx(Image, { url: imageUrl, status: "loaded", alt: product?.title || 'Product Image', customStyle: {
                    width: '100%',
                    height: imageHeight,
                    ...(effectiveMaxHeight !== undefined && { maxHeight: effectiveMaxHeight }),
                    objectFit: imageObjectFit,
                    objectPosition: isHorizontal ? 'top' : 'center',
                    ...(isHorizontal && {
                        borderTopLeftRadius: borderStyle.borderRadius || 0,
                        borderBottomLeftRadius: borderStyle.borderRadius || 0,
                    }),
                } }) })) }));
};
CardImage.defaultProps = {
    onClick: undefined,
    height: undefined,
    maxHeight: undefined,
    objectFit: 'contain',
    imageClickable: false,
    borderStyle: {},
    isHorizontal: false,
};
export default CardImage;
//# sourceMappingURL=CardImage.js.map